// Product-card Alpine factories. Deferred, non-module. Registers on alpine:init
// and also immediately if Alpine is already present. Loaded once from layout/primary.liquid.
(function () {
  function formatMoney(price) {
    var amount = Number(price);
    return amount % 1 === 0 ? String(amount) : amount.toFixed(2);
  }

  function register() {
    if (window.__ceProductCardRegistered) return;
    window.__ceProductCardRegistered = true;

    Alpine.data("ceCardSlider", function (totalSlides) {
      return {
        totalSlides: totalSlides,
        scrollPercentage: 0,
        hideProgress: false,

        updateScroll: function () {
          var scrollContainer = this.$refs.scrollContainer;
          var scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
          var currentScroll = scrollContainer.scrollLeft;
          if (scrollWidth > 0) {
            this.scrollPercentage =
              ((currentScroll / scrollWidth) * (1 - 1 / this.totalSlides) + 1 / this.totalSlides) * 100;
          }
        },

        initScroll: function () {
          var scrollContainer = this.$refs.scrollContainer;
          scrollContainer.scrollLeft = 0;
          this.scrollPercentage = (1 / this.totalSlides) * 100;
        },

        init: function () {
          this.initScroll();
        },

        showScrollability: function () {
          var self = this;
          this.$refs.scrollContainer.style.scrollSnapType = "none";
          this.$refs.scrollContainer.scrollLeft = 0;
          setTimeout(function () {
            self.$refs.scrollContainer.scrollTo({ left: 100, behavior: "smooth" });
            self.updateScroll();
            setTimeout(function () {
              self.$refs.scrollContainer.scrollTo({ left: 0, behavior: "smooth" });
              self.updateScroll();
              self.$refs.scrollContainer.style.scrollSnapType = "";
            }, 200);
          }, 1000);
        },

        hideProgressBar: function () {
          this.hideProgress = true;
        },
      };
    });

    Alpine.data("ceCardSwatches", function (productId) {
      return {
        imgs: null,

        init: function () {
          var el = document.getElementById("variant-images-" + productId);
          this.imgs = el ? JSON.parse(el.textContent) : {};
        },

        swapVariantImage: function (variantId) {
          var data = this.imgs && this.imgs[variantId];
          if (!data) return;

          var article = this.$el.closest("article");
          if (!article) return;

          var primary = article.querySelector(".featured-media");
          if (primary) {
            primary.src = data.src;
            primary.srcset = data.srcset;
            primary.alt = data.alt || primary.alt;
          }

          var secondary = article.querySelector(".secondary-media");
          if (secondary) {
            secondary.setAttribute("hidden", "true");
          }
        },

        selectSwatch: function (event) {
          var input = event.target;
          if (!input || !input.dataset || !input.dataset.variantId) return;

          var variantId = input.dataset.variantId;
          var parent = this.$el._x_dataStack && this.$el._x_dataStack[1];
          if (parent) parent.selectedVariantId = variantId;
          this.swapVariantImage(variantId);
          this.$dispatch("product-card:variant-changed", {
            uniqueId: parent && parent.uniqueId,
          });
        },
      };
    });

    Alpine.data("ceCardPrice", function (variantId, mode) {
      return {
        updatePrices: function () {
          var experiments = window.igData && window.igData.user && window.igData.user.getExperiments();
          var refs = this.$refs;

          if (mode === "compare") {
            var removeHiddenClasses = function () {
              if (refs.retailPrice) refs.retailPrice.classList.remove("hidden");
              if (refs.discountPrice) refs.discountPrice.classList.remove("hidden");
              if (refs.savings) refs.savings.parentElement.classList.remove("hidden");
              if (refs.discountPrice && refs.retailPrice) {
                refs.retailPrice.classList.add("line-through");
              }
            };

            if (experiments && experiments.length) {
              var price = window.igData.price.getPriceByVariantId(variantId);
              var retailPrice = window.igData.price.getComparePriceByVariantId(variantId);
              if (price === null) {
                removeHiddenClasses();
                return;
              }

              var savings = 0;
              if (retailPrice) {
                refs.retailPrice.textContent = "$" + formatMoney(retailPrice);
                savings = Math.round((1 - price / retailPrice) * 100);
              }

              if (price) refs.discountPrice.textContent = "$" + formatMoney(price);

              if (typeof savings === "number" && savings > 0) {
                refs.savings.textContent = Math.round(savings / 10) * 10;
                refs.savings.parentElement.classList.remove("hidden");
              } else if (price) {
                refs.retailPrice.textContent = "$" + formatMoney(price);
              }

              refs.retailPrice.classList.remove("hidden");

              if (retailPrice && Number(retailPrice) > Number(price)) {
                refs.discountPrice.classList.remove("hidden");
                refs.retailPrice.classList.add("line-through");
              }
            } else {
              removeHiddenClasses();
            }
            return;
          }

          if (experiments && experiments.length) {
            var experimentPrice = window.igData.price.getPriceByVariantId(variantId);
            if (mode === "fixed") {
              if (experimentPrice !== null) {
                refs.discountPrice.textContent = "$" + formatMoney(experimentPrice);
              }
            } else if (experimentPrice) {
              refs.discountPrice.textContent = "$" + experimentPrice;
            }
          }
          refs.discountPrice.classList.remove("hidden");
        },

        init: function () {
          var self = this;
          if ((window.igData && window.igData.user) || !window.intelligemsScript) {
            this.updatePrices();
          } else {
            window.addEventListener("ig:ready", function () {
              self.updatePrices();
            });
          }
        },
      };
    });
  }

  function selectedVariantFrom(el) {
    var node = el;
    while (node) {
      var stack = node._x_dataStack;
      if (stack) {
        for (var i = 0; i < stack.length; i++) {
          var scope = stack[i];
          if (scope && typeof scope.selectedVariantId !== "undefined") {
            return scope.selectedVariantId;
          }
        }
      }
      node = node.parentElement;
    }
    return undefined;
  }

  window.ceOpenProductCard = function (event) {
    var el = event.currentTarget;
    var href = el.href;

    if (el.dataset.plainLink === "true") {
      var selectedVariantId = selectedVariantFrom(el);
      if (typeof selectedVariantId !== "undefined" && selectedVariantId) {
        try {
          var url = new URL(href, window.location.origin);
          url.searchParams.set("variant", selectedVariantId);
          href = url.toString();
        } catch (e) {}
      }
    }

    try {
      localStorage.setItem("breadcrumbUrl", window.location.pathname + window.location.search);
      localStorage.setItem("breadcrumbTitle", el.dataset.breadcrumbTitle || "");
      localStorage.setItem("breadcrumbProduct", el.dataset.breadcrumbProduct || "");

      if (el.dataset.storeGrid === "true") {
        var grid = document.querySelector("#collection-grid");
        if (grid) {
          localStorage.setItem("breadcrumbGrid", grid.innerHTML);
        }
      }

      if (window.location.pathname.startsWith("/search")) {
        localStorage.setItem("breadcrumbSearch", window.location.href.split("#product-card")[0]);
      }

      try {
        var plpGrid = document.getElementById("collection-grid");
        if (
          plpGrid &&
          (window.location.pathname.startsWith("/collections") || window.location.pathname.startsWith("/search"))
        ) {
          sessionStorage.setItem(
            "plpState:" + window.location.pathname + window.location.search,
            JSON.stringify({
              html: plpGrid.innerHTML,
              scrollY: window.scrollY,
              ts: Date.now(),
            })
          );
        }
      } catch (e) {}

      window.location.href = href;
    } catch (e) {
      window.location.href = href;
    }
  };

  if (window.Alpine) register();
  else document.addEventListener("alpine:init", register);
})();
